import { DevOpsAction } from "../models/DevOpsAction";

export class GetDevOpsActionDetailsResponse {
    eventRule?: DevOpsAction;
}